export interface Props
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  isOpen: boolean;
  onClose: () => unknown;
  children: React.ReactNode;
  backgroundColor: string;
  containerClassName: string;
  closeOnOverlayClick?: boolean;
  showCloseIcon?: boolean;
  closeOnEsc?: boolean;
  type?: string;
}

// eslint-disable-next-line no-restricted-syntax
export enum Key {
  TAB = 'Tab',
  SHIFT = 16,
  ESCAPE = 'Escape',
  ESC = 'Esc',
  SPACE = ' ',
  ENTER = 'Enter',
}
